var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('HomeplaceModal',{attrs:{"state":_vm.state,"strategy":_vm.strategy},on:{"close":_vm.navigateToSettings}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }